import TSettingBusinessHoursEditBusinessHours from './index.vue';

TSettingBusinessHoursEditBusinessHours.install = app => {
  app.component(TSettingBusinessHoursEditBusinessHours.name, TSettingBusinessHoursEditBusinessHours);
};

export default TSettingBusinessHoursEditBusinessHours;
